import { render, staticRenderFns } from "./FileReport.vue?vue&type=template&id=33f6fe32&scoped=true&"
import script from "./FileReport.vue?vue&type=script&lang=js&"
export * from "./FileReport.vue?vue&type=script&lang=js&"
import style0 from "./FileReport.vue?vue&type=style&index=0&id=33f6fe32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f6fe32",
  null
  
)

export default component.exports